/**
 * Formats a number with spaces as thousands separators
 * @param num - The number to format
 * @returns The formatted number string with spaces
 */
export function formatNumberWithSpaces(num: number): string {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

/**
 * Formats tokens balance with spaces as thousands separators
 * @param num - The number to format
 * @returns The formatted number string with spaces
 */
export function formatTokensNumber(num: number): string {
  const formatedNum = num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  if (formatedNum == "-0") {
    return "0";
  }
  return formatedNum;
}

/**
 * Formats tokens with K (thousands) or M (millions) suffix
 * Examples: 340000 → "340K tokens left", 1560000 → "1.6M tokens left", 39620 → "39.7K tokens left", 0 → "out of tokens"
 */
export function formatTokensCompact(num: number): string {
  // Round to eliminate floating-point precision issues from backend calculations
  const rounded = Math.round(num);

  if (rounded <= 0) {
    return "out of tokens";
  }

  if (rounded >= 1_000_000) {
    // Millions: 1 decimal place, trim .0
    const millions = rounded / 1_000_000;
    const formatted = millions.toFixed(1).replace(/\.0$/, "");
    return `${formatted}M tokens left`;
  }

  if (rounded >= 1_000) {
    // Thousands: 1 decimal place, trim .0
    const thousands = rounded / 1_000;
    const formatted = thousands.toFixed(1).replace(/\.0$/, "");
    return `${formatted}K tokens left`;
  }

  // Under 1000: show raw number
  return `${rounded} tokens left`;
}
